
import { Component, Vue, Prop } from "vue-property-decorator";

import programs_routes from "@/api/routes/programs";
import users_routes from "@/api/routes/users";

import DateTimePicker from "@/components/DateTimePicker.vue";

import UserUser from "@/models/user/user";
import { EAdmissionPermission } from "@/models/admission/permission";

@Component({
  name: "CProgramAgreementAdmin",
  components: {
    DateTimePicker
  }
})
export default class CProgramAgreementAdmin extends Vue {
  @Prop({ required: true }) public program_id!: string;

  @Prop({ required: false, default: true })
  public show_btn!: boolean;

  public disabled: boolean = false;

  public responsibles: UserUser[] = [];
  public selected_responsible_id: string | null = null;
  public selected_responsible_errors: string | null = null;

  public comment: string = "";
  public approve_at: Date = new Date();

  protected async created() {
    await this.loadResponsibles();
  }

  public setDate(date: Date | string) {
    this.approve_at = date instanceof Date ? date : new Date(date);
  }

  public async sendApproval() {
    this.selected_responsible_errors = null;

    if (!this.selected_responsible_id?.length) {
      this.selected_responsible_errors =
        "Выберите сотрудника для согласования программы";
    }

    if (this.selected_responsible_errors) {
      return;
    }

    return this.$api
      .post(programs_routes.confirm_approval_admin(this.program_id), {
        approve_at: this.approve_at,
        comment: this.comment,
        responsible_id: this.selected_responsible_id
      })
      .then(({ data: res }: { data: { message: string } }) => {
        this.$notify({
          group: "notifications",
          type: "success",
          text: res.message,
          speed: 500
        });

        setTimeout(() => {
          this.$router.go(0);
        }, 1000);
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }

  private async loadResponsibles() {
    return this.$api
      .get(users_routes.users, {
        params: {
          paginate: false,
          only_my: false,
          permission_id: EAdmissionPermission.EDUCATION_PROGRAMS
        }
      })
      .then(({ data: res }: { data: { users: UserUser[] } }) => {
        this.responsibles = res.users;
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }

  public showAgreementModal() {
    this.$modal.show("agreement_admin_program_modal");
  }

  public hideModal() {
    this.$modal.hide("agreement_admin_program_modal");
  }
}
